import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@src/environments/environment';
import {
  LegitimationFaxInfoModel,
  LegitimationListModel,
  LegitimationPostModel,
  LegitimationStatusResponse
} from '@store/legitimation/legitimation.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LegitimationApi {
  readonly #http = inject(HttpClient);

  postSaveLegitimationInfo$(data: LegitimationPostModel, userId: number, eventId: number) {
    return this.#http.post<LegitimationPostModel>(
      `${environment.protocol}${environment.webApiUrl}/event/${eventId}/legitimation/${userId}`,
      data
    );
  }

  getLegitimationList$(): Observable<LegitimationListModel[]> {
    return this.#http.get<LegitimationListModel[]>(
      `${environment.protocol}${environment.webApiUrl}/user/legitimation-history`
    );
  }

  getLegitimationStatus$(eventId: number) {
    return this.#http.get<LegitimationStatusResponse>(
      `${environment.protocol}${environment.webApiUrl}/user/event/${eventId}/legitimation-status`
    );
  }

  getLegitimationFaxId$(eventId: number, userId: number) {
    return this.#http.get<LegitimationFaxInfoModel>(
      `${environment.protocol}${environment.webApiUrl}/event/${eventId}/fax-legitimation-id/${userId}`
    );
  }
}
